export default "__VITE_ASSET__C96rbhmg__"